import { useQuery } from '@tanstack/react-query';
import { appointmentsAPI, companiesAPI, usersAPI, designationsAPI } from '../lib/api.js';


// Custom hook for companies with longer cache time
export const useCompanies = () => {
  return useQuery({
    queryKey: ['companies'],
    queryFn: () => companiesAPI.getAll({ limit: 1000 }), // Get all companies by setting a large limit
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false,
  });
};

// Custom hook for designations with longer cache time
export const useDesignations = () => {
  return useQuery({
    queryKey: ['designations'],
    queryFn: () => designationsAPI.getAllSimple(), // Use simple endpoint for dropdowns
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false,
  });
};

// Custom hook for users with longer cache time
export const useUsers = () => {
  return useQuery({
    queryKey: ['users'],
    queryFn: () => usersAPI.getAll(),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
};


// Helper function to get company name by ID
export const useCompanyName = (companyId) => {
  const { data: companies } = useCompanies();
  
  if (!companyId || !companies?.data?.data) {
    return 'Not assigned';
  }
  
  const company = companies.data.data.find(c => c.id === companyId);
  return company?.name || 'Not assigned';
};

// Helper function to get user name by ID
export const useUserName = (userId) => {
  const { data: users } = useUsers();
  
  if (!userId || !users?.data?.data) {
    return 'Not assigned';
  }
  
  const user = users.data.data.find(u => u.id === userId);
  return user ? `${user.first_name} ${user.last_name}` : 'Not assigned';
};
